import * as React from "react"
import { Parallax } from "@react-spring/parallax"
import Layout from "../components/layout"
import Hero from "../components/hero"
import Intro from "../components/intro"
import Projects from "../components/projects"
import About from "../components/about"
import Fees from "../components/fees"
import Contact from "../components/contact"

const Cara = () => (
  <Layout>
    <Parallax pages={6}>
      <Hero offset={0.1} factor={1} />
      <Intro offset={1} factor={1} />
      <Projects offset={1.8} factor={1} />
      <Fees offset={3} factor={1} />
      <About offset={4} factor={1} />
      <Contact offset={5} factor={1} />
    </Parallax>
  </Layout>
)

export default Cara
